<template>
    <div class="x-select">
        <label class="x-label">
            {{ label }}
            <slot name="label"></slot>
        </label>
        <div style="display: flex">
            <el-select :value="value"
                       :disabled="disable"
                       :filterable="filterable"
                       :clearable="clearable"
                       @input="handleInput($event)"
                       :class="{'with-button-new': showButtonNew}" >
                <el-option v-for="option in options" :key="option[optionValue]" :value="option[optionValue]"
                           :label="option[optionLabel]"></el-option>
            </el-select>
            <el-button plain
                       icon="el-icon-plus"
                       type="primary"
                       size="mini"
                       style="font-size: 20px;
                            outline: none;
                            padding: 0;
                            width: 40px;
                            border-bottom-left-radius: 0;
                            border-top-left-radius: 0;
                            border-left: 0;"
                       @click.prevent="$emit('click-new')"
                       v-if="showButtonNew"></el-button>
        </div>
        <small v-if="!!error" class="x-label-error" v-text="error"></small>
    </div>
</template>

<script>
export default {
    name: 'XSelect',
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            default: ''
        },
        options: {
            default: []
        },
        optionValue: {
            type: String,
            default: 'id'
        },
        optionLabel: {
            type: String,
            default: 'name'
        },
        inputClass: {
            type: String,
            default: null,
        },
        disable: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showButtonNew: {
            type: Boolean,
            default: false
        },
        error: {
            default: null,
        }
    },
    data() {
        return {}
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
    }
}
</script>
